export class AppUserInformation {
  constructor(
    public id: number | null = null,
    public user_id: number | null = null,
    public information: {
      billing_information: {
        name: string;
        address: string;
        city: string;
        province: string;
        country: string;
        postal_code: string;
        phone: string;
        email: string;
      };
      delivery_information: {
        name: string;
        address: string;
        city: string;
        province: string;
        country: string;
        postal_code: string;
        phone: string;
        email: string;
      };
      currency: number | null;
    } = {
      billing_information: {
        name: "",
        address: "",
        city: "",
        province: "",
        country: "",
        postal_code: "",
        phone: "",
        email: "",
      },
      delivery_information: {
        name: "",
        address: "",
        city: "",
        province: "",
        country: "",
        postal_code: "",
        phone: "",
        email: "",
      },
      currency: null,
    },
    public created_at: string = "",
    public updated_at: string = ""
  ) {}
}
